export default {"src":"/_next/static/media/padlock.8e8e9f10.svg","height":20,"width":18};